// src/AppRoutes.js
import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './components/Login';
import HomePage from './components/HomePage';
import About from './components/About';
import Companies from './components/Companies';
import Request from './components/Request';
import AdminDashboard from './components/AdminDashboard';
import ProfileUpdate from './components/ProfileUpdate';
import Opportunity from './components/opportunities';
import IndustryDetails from './components/IndustryDetails';
import UpdatePassword from './components/UpdatePassword';
import ProtectedRoute from './components/ProtectedRoute';

import Events from './components/Events';
import ForgotPassword from './components/ForgotPassword';
import Newsandevents from './components/Newsandevents';
const AppRoutes = () => {
  const { loading } = useContext(AuthContext);

  if (loading) return <div>Loading...</div>;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<About />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="home" element={<HomePage />} />
          <Route path="about" element={<About />} />
          <Route path="companies" element={<Companies />} />
          <Route path="request" element={<Request />} />
          <Route path="admin" element={<AdminDashboard />} />
          <Route path="profile-update" element={<ProfileUpdate />} />
          <Route path="opportunities" element={<Opportunity />} />
          <Route path="industry/:name" element={<IndustryDetails />} />
          <Route path="updatepassword" element={<UpdatePassword />} />
          <Route path="events" element={<Events />} />  
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
